import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NormalImg from '../common/Img';
import LogoImg from '../participants/bicamsinlogo.jpg';
import Button from '../common/Button';
import { fetchParticipant, newExam } from '../../actions';
import NewExamForm from './NewExamForm';


const Img = styled(NormalImg)`
  width: 200px;
  margin: 20px;
  display: block;
`;
const ButtonA = styled(Button)`
  background: #324971;
  color: #fff;
`;
const ButtonB = styled(Button)`
  background: #7A062D;
  color: #fff;
`;




class NewExamPage extends React.Component {
    
  state = {
    redirect: false
  }

    componentDidMount = () => {
    const { match } = this.props;
    
    if (match.params.id) {
      this.props.fetchParticipant(match.params.id);
    }
  }
  
  newExam = ({ id, NoExams, age, yearsEducation, diagnosis, diseaseSubtype, yearsDiagnosis, countryExam, examLanguage, examNorms }) => {
    return this.props.newExam({ id, NoExams, age, yearsEducation, diagnosis, diseaseSubtype, yearsDiagnosis, countryExam, examLanguage, examNorms });
    //.then(() => { this.setState({ redirect: true })},
    //);
  }
    
    render() {
        //console.log();
        return (
            <div className="normalPage">
              
             
               <div className="container"> 

                   <div className="row">
                        <div className="col-xs-6">
                        <Img src={LogoImg} alt="BICAMS Logo" />
                        </div>
                        <div className="col-xs-6"> 
                        
                        <Link to="/participants"><ButtonA className="btn btn-lg">Go back </ButtonA></Link>
                        <Link to="/logout"><ButtonB className="btn btn-lg">Logout</ButtonB></Link>
                        </div>
                    </div>  
                    {
          this.state.redirect ?
          <div className="row">
          <div className="col-md-12">
          <h1 className="bicamsColor">Exam created</h1>
          <h2>BICAMS Exam NUMBER: {this.state.exam.NoExams}</h2>
          
          <Link to="/app_sync"><ButtonA className="btn btn-lg">Sync</ButtonA></Link>
          </div>
          </div>
            : <NewExamForm participant={this.props.participant} newExam={this.props.newExam}/>   
           }     

               </div> 
              
            </div>
        );
    }
}

function mapStateToProps(state, props) {
  const { match } = props;
  if (match.params.id) {
    return {
      participant: state.participants.find(item => item.Id === parseInt(match.params.id,10)),
      exams: state.exam
    }
  }

  return { participant: null, exam: null };
}

export default connect(mapStateToProps, { fetchParticipant, newExam})(NewExamPage);


// WEBPACK FOOTER //
// ./src/components/exam/NewExamPage.js